import { Box, Chip } from '@mui/material';
import { DAY_LABELS } from './constants';

const DayToggle = ({ value = '', onChange }) => (
  <Box display="flex" gap={0.5}>
    {[1, 2, 3, 4, 5, 6, 7].map((d) => {
      const active = value.includes(String(d));
      return (
        <Chip
          key={d}
          label={DAY_LABELS[d][0]}
          size="small"
          color={active ? 'primary' : 'default'}
          variant={active ? 'filled' : 'outlined'}
          onClick={() => {
            const next = active
              ? value.replace(String(d), '')
              : [...value.replace(/[^1-7]/g, ''), String(d)].sort().join('');
            onChange(next);
          }}
          sx={{ cursor: 'pointer', userSelect: 'none', minWidth: 28, px: 0 }}
        />
      );
    })}
  </Box>
);

export default DayToggle;
